(function () {
  function variants() {
    try { var s = document.getElementById('pp-variants-data'); return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function currentId() {
    var u = new URLSearchParams(location.search).get('variant');
    if (u) return u;
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"]:checked');
    if (sel) return sel.value;
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return inp ? inp.value : null;
  }
  function priceFor(id) {
    var vs = variants(); if (!vs) return null;
    for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === String(id)) return vs[i].price / 100; }
    return null;
  }
  function refresh() {
    var el = document.querySelector('[data-pp-message]'); if (!el) return;
    var p = priceFor(currentId()); if (p == null) return;
    if (String(el.getAttribute('data-pp-amount')) === String(p)) return;
    el.setAttribute('data-pp-amount', p);
    if (window.paypalMessages && window.paypalMessages.Messages) {
      el.innerHTML = '';
      try { window.paypalMessages.Messages({ amount: p, placement: 'product', style: { layout: 'text', logo: { type: 'inline' }, text: { color: 'black' } } }).render(el); } catch (e) {}
    }
  }
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && (t.name === 'id' || (t.closest && t.closest('variant-selects,variant-radios,.product-form,form[action*="/cart/add"]')))) setTimeout(refresh, 80);
  }, true);
  var last = location.href;
  setInterval(function () { if (location.href !== last) { last = location.href; refresh(); } }, 700);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 1000); }); else setTimeout(refresh, 1000);
})();